/**
 * Public Sans is loaded in public/index.html (Google Fonts).
 * Use these tokens in sidebar / navigation so weights can differ per component (e.g. 500 menu, 600 headings).
 */
export const PUBLIC_SANS_FONT_FAMILY =
  '"Public Sans", -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif'

/** Default weight for sidebar menu labels */
export const SIDEBAR_MENU_FONT_WEIGHT = 500
